import {
  useDashboardPeriodFetch,
  useDashboardPeriodParams,
  type DashboardPeriodFetchState,
} from './useDashboardPeriod'
import type { RangeKey } from '@dataTypes/dashboard.types'
import {
  getScheduleOperationsOverview,
  type ScheduleOperationsOverviewResult,
} from '@services/api/dashboard/operations-schedule.api'

export function useScheduleOperationsOverview(
  range: RangeKey,
  date: string,
  enabled = true,
  queued = false,
): DashboardPeriodFetchState<ScheduleOperationsOverviewResult> {
  const queryParams = useDashboardPeriodParams(range, date)
  return useDashboardPeriodFetch(queryParams, getScheduleOperationsOverview, {
    enabled,
    queued,
  })
}
